import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import { logoutAction } from '../../../../core/redux/actions/logout-action';
import store from '../../../../core/redux/store';

export const getMe = async (): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.base_url}/me`;
    const options = {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        store.dispatch(logoutAction());
      }
      store.dispatch(logoutAction()); // assume all errors are auth related n kickout user
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
